import { createSlice } from "@reduxjs/toolkit";

export const uploadSlice = createSlice({
  name: "upload",
  initialState: {
    isUploadingFiles: false,
    uploadFilesProgressPercent:[],

  },
  reducers: {
    uploadFilesStatusChangeRequest: (state, action) => {
      state.isUploadingFiles = action.payload;
    },
    uploadFileProgressChange: (state, action) => {
      state.uploadFilesProgressPercent = action.payload;
    },
  },
});

export const {
  uploadFilesStatusChangeRequest,
  uploadFileProgressChange,
} = uploadSlice.actions;
export default uploadSlice.reducer;
